(function() {
  'use strict';
  
  document.addEventListener('DOMContentLoaded', function() {
    // Scroll-based highlight animation
    const highlightSpans = document.querySelectorAll('.p-herbs-carousel-text-highlight');
    const viewportMid = window.innerHeight * 0.9;

    function toggleHighlightOnScroll() {
      highlightSpans.forEach(span => {
        const rect = span.getBoundingClientRect();
        const spanCenter = rect.top + rect.height / 2;

        if (spanCenter <= viewportMid) {
          span.classList.add('active');
        } else {
          span.classList.remove('active');
        }
      });
    }

    window.addEventListener('scroll', toggleHighlightOnScroll);
    toggleHighlightOnScroll(); // Initial check

    // Carousel navigation
    const track = document.querySelector('.p-herbs-carousel-track');
    const prevButton = document.querySelector('.p-herbs-carousel-btn-prev');
    const nextButton = document.querySelector('.p-herbs-carousel-btn-next');
    const cards = document.querySelectorAll('.p-herbs-carousel-card');
    const cardWidth = cards[0].offsetWidth;
    let currentIndex = 1;
    const progressIndicator = document.querySelector('.p-herbs-carousel-progress-indicator');
    const totalCards = cards.length - 3; // Adjust for actual total non-cloned cards

    // Set initial position
    track.style.transform = `translateX(-${cardWidth * currentIndex}px)`;

    function updateCarousel(direction) {
      if (direction === 'next') {
        currentIndex++;
        if (currentIndex > totalCards) {
          currentIndex = totalCards; // Prevent moving beyond the last card
        }
      } else if (direction === 'prev') {
        currentIndex--;
        if (currentIndex <= 1) {
          currentIndex = 1;
        }
      }
      track.style.transform = `translateX(-${cardWidth * currentIndex}px)`;
      updateButtons();
      updateProgressBar();
    }

    function updateProgressBar() {
      const progressPercentage = ((currentIndex - 1) / (totalCards - 1)) * 100;
      progressIndicator.style.width = `${progressPercentage}%`;
    }

    function updateButtons() {
      prevButton.disabled = currentIndex <= 1;
      nextButton.disabled = currentIndex >= totalCards;

      // Add or remove disabled class for visual feedback
      prevButton.classList.toggle('disabled', prevButton.disabled);
      nextButton.classList.toggle('disabled', nextButton.disabled);
    }

    prevButton.addEventListener('click', () => updateCarousel('prev'));
    nextButton.addEventListener('click', () => updateCarousel('next'));

    // Initialize the carousel
    updateProgressBar();
    updateButtons();
  });
})();
